import React, { useState, Fragment } from 'react';
import { graphql } from '@apollo/react-hoc';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import _ from 'lodash';
import axios from 'axios';
import styles from './navbar.module.scss';
import getUser from '../../queries/user';
import LoginModal from '../LoginModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const AccountDropdown = ({ data }) => {
	const [open, setOpen] = useState(false);
	const [loginModal, setLoginModal] = useState(false);
	const classes = cn(styles.dropDownMenu, { [styles.open] : open });
	const user = _.get(data, 'user');
	return (
		<div className={styles.dropDown}>
			{
				loginModal &&
				<LoginModal
					show={loginModal}
					onHide={() => setLoginModal(false)}
					reload={() => { data.refetch(); setOpen(false); }}
				/>
			}
			<h3 onClick={() => setOpen(!open)}>Account</h3>
			<div className={classes}>
				{status(data, user, setLoginModal, setOpen)}
			</div>
		</div>
	);
}

function status(data, user, setLoginModal, setOpen) {
	return user ? renderUserMenu(data, setOpen, user) : renderGuestMenu(setLoginModal);
}

function renderUserMenu(data, setOpen, user) {
	console.log(user);
	return (
		<Fragment>
			<span>
				<FontAwesomeIcon icon={['fas', 'user']} size='2x' />
				<br />
				Welcome {user.firstname}
				<br/>
				{user.email}
			</span>
			<span className={styles.seperator} />
			{ user.accountType > 0 && <div onClick={() => openBackoffice()}>Open Backoffice</div> }
			<Link as='div' to='/user'>Manage</Link>
			<div onClick={() => logout(data, setOpen)}>Logout</div>
		</Fragment>
	);
}

function renderGuestMenu(setLoginModal) {
	return (
		<div onClick={() => setLoginModal(true)}>Login</div>
	);
}

async function logout(data, setOpen) {
	await axios.get('/api/logout');
	data.refetch();
	setOpen(false);
}

function openBackoffice() {
	window.open('https://office.peoplefourpeople.com', '_blank');
}

export default graphql(getUser)(AccountDropdown);